import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'legalMatter/stage/autocomplete';

export const invalidateAllLegalMatterStageAutocomplete = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};

export function useLegalMatterStageAutocompleteQuery({
	enabled,
	fragment,
	pageSize = 25,
}: {
	enabled?: boolean;
	fragment: string;
	pageSize?: number;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ILegalMatterStage>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: {
						fragment,
						pageSize,
						pageToken: pageParam,
					},
					urlPath: 'legalMatter/stage/autocomplete',
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, fragment, pageSize],
		initialPageParam: '',
	});
}
